<style scope>
  .w-full { width: 100% }
</style>

<template>
  <div>
    <b-loading :is-full-page="true" :active.sync="isLoading"></b-loading>
    <b-table :data="lista" :loading="loading" class="row-click"
               :paginated="true" detailed>
        <portal-lista-vazia slot="empty"/>

        <template slot-scope="props">

          <b-table-column label="Pedido">
            {{ props.row.CODIGO }}
          </b-table-column>

          <b-table-column label="Código Web">
            {{ props.row.CODIGOWEB }}
          </b-table-column>

          <b-table-column label="Cliente">
          {{ props.row.cliente.A1_NOME }}
          </b-table-column>

          <b-table-column label="Data Emissão">
            {{ props.row.DT_EMISSAO | moment("DD/MM/YYYY") }}
          </b-table-column>

          <b-table-column label="Data Entrega">
            {{ props.row.DT_ENTREGA | moment("DD/MM/YYYY") }}
          </b-table-column>

          <b-table-column label="Descontos" :visible="parametros.PERMITE_DESC_CABECALHO === 'S'">
            <b-tag v-if="props.row.descontos">{{props.row.descontos}}</b-tag>
            <!--<b-tag>{{props.row.DESC1}}%</b-tag>-->
            <!--<b-tag>{{props.row.DESC2}}%</b-tag>-->
            <!--<b-tag v-if="parametros.DESCONTO_3_VISIVEL ==='S'">{{props.row.DESC3}}%</b-tag>-->
            <!--<b-tag>{{props.row.DESC4}}%</b-tag>-->
          </b-table-column>

          <b-table-column label="Total">
            {{ props.row.VALOR | moeda }}
          </b-table-column>

          <b-table-column label="Status" >
              <b-tag type="is-warning" v-if="props.row.STATUS && props.row.STATUS.length > 1 ">
                {{props.row.STATUS}}
              </b-tag>
          </b-table-column>

          <b-table-column label="Nota Fiscal" >
            <button class="button is-small is-info" @click="carregar(props.row)"
                    v-if="props.row.NUMNOTA" title="Visualizar notas">
              <b-icon icon="eye-outline" size="is-small"/>
              <span>{{props.row.NUMNOTA}}</span>
            </button>
            <b-tag type="is-danger" v-else>Não Faturado</b-tag>
          </b-table-column>

          <b-table-column label="" :visible="props.row.CODIGO !== null">
            <!--<a class="button is-small" :download="'PEDIDO_'+props.row.CODIGO+'.pdf'"-->
               <!--:href="$URL.DOWNLOAD.PEDIDO+props.row.CODIGO">-->
                  <!--<b-icon icon="file-pdf"/>-->
            <!--</a>-->
            <button class="button is-small" @click="downloadPedido(props.row.CODIGO)"
                    title="Download">
              <b-icon icon="file-pdf"/>
            </button>
          </b-table-column>

        </template>

        <template slot="detail" slot-scope="props">
          <table class="table is-fullwidth m-t-sm" v-if="props.row.itens.length > 0" >
            <tr>
              <th>Item</th><th>Código</th><th>Descrição</th><th>Qtd</th>
              <th v-if="parametros.EMPRESA_NOME ==='ISERO'">VL Unit</th>
              <th v-if="parametros.EMPRESA_NOME ==='ISERO'">Desc</th>
              <th v-if="parametros.EMPRESA_NOME ==='ISERO'">VL Liq</th>
              <th>Valor Total</th><th>Nota</th> <th>Serie</th>
            </tr>
            <tr v-for="(item,i) in props.row.itens" :key="i">
              <td>{{ item.C6_ITEM }}</td>
              <td>{{ item.C6_PRODUTO }}</td>
              <td>{{ item.C6_DESCRI }}</td>
              <td>{{ item.C6_QTDVEN }}</td>
              <td v-if="parametros.EMPRESA_NOME ==='ISERO'">{{item.C6_XPRCTAB | moeda }}</td>
              <td v-if="parametros.EMPRESA_NOME ==='ISERO'">{{item.C6_XDESC}}%</td>
              <td v-if="parametros.EMPRESA_NOME ==='ISERO'">{{item.C6_PRCVEN | moeda }}</td>
              <td>{{ item.C6_VALOR | moeda }}</td>
              <td>{{ item.C6_NOTA }}</td>
              <td>{{ item.C6_SERIE }}</td>
            </tr>
          </table>
        </template>

      </b-table>

  </div>
</template>

<script>
  import DetalheNota from './DetalheNota'

  export default {
    props: ['lista', 'loading', 'parametros'],
    data () {
      return {
        isLoading: false
      }
    },
    methods: {
      carregar (pedido) {
        pedido = this.$clonar(pedido)
        this.$modal.open({
          component: DetalheNota,
          canCancel: true,
          width: 'auto',
          props: {objeto: pedido}
        })
      },
      downloadPedido (codigo) {
        this.isLoading = true
        this.$http({
          method: 'get',
          url: this.$URL.DOWNLOAD.PEDIDO + codigo,
          responseType: 'arraybuffer'
        })
          .then(response => {
            // console.log(response.data)
            const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'PEDIDO_' + codigo + '.pdf')
            document.body.appendChild(link)
            link.click()
            this.isLoading = false
          })
          .catch((response) => {
            this.$toast.open({
              message: 'Não foi possível localizar o pedido para download.',
              type: 'is-danger',
              duration: 4 * 1000
            })
            this.isLoading = false
          })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/pedido/ListaFabrica.vue